<app-selector
  label="Snake Ladder Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="snakeLadderGameCoreService.snakeLadderGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="snakeLadderGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
